import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import {
    FAILURE_CREATE_LANGUAGE_BLOCK,
    FAILURE_EDIT_LANGUAGE_BLOCK_TRANSLATION,
    FAILURE_FETCH_ALL_LANGUAGE_BLOCKS,
    FAILURE_FETCH_ALL_REGION_BLOCKS,
    FAILURE_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY,
    FAILURE_FETCH_LANGUAGE_BLOCKS_BY_QUERY,
    FAILURE_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY,
    FAILURE_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY,
    FAILURE_FETCH_TEXT_BLOCK_LANGUAGES,
    REQUEST_CREATE_LANGUAGE_BLOCK,
    REQUEST_EDIT_LANGUAGE_BLOCK_TRANSLATION,
    REQUEST_FETCH_ALL_LANGUAGE_BLOCKS,
    REQUEST_FETCH_ALL_REGION_BLOCKS,
    REQUEST_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY,
    REQUEST_FETCH_LANGUAGE_BLOCKS_BY_QUERY,
    REQUEST_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY,
    REQUEST_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY,
    REQUEST_FETCH_TEXT_BLOCK_LANGUAGES,
    SUCCESS_CREATE_LANGUAGE_BLOCK,
    SUCCESS_EDIT_LANGUAGE_BLOCK_TRANSLATION,
    SUCCESS_FETCH_ALL_LANGUAGE_BLOCKS,
    SUCCESS_FETCH_ALL_REGION_BLOCKS,
    SUCCESS_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY,
    SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_QUERY,
    SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY,
    SUCCESS_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY,
    SUCCESS_FETCH_TEXT_BLOCK_LANGUAGES,
} from './actions';

export function templateAdminReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CREATE_LANGUAGE_BLOCK:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_LANGUAGE_BLOCK:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_CREATE_LANGUAGE_BLOCK:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        case REQUEST_EDIT_LANGUAGE_BLOCK_TRANSLATION:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EDIT_LANGUAGE_BLOCK_TRANSLATION:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_EDIT_LANGUAGE_BLOCK_TRANSLATION:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function templateLanguageBlocksReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_ALL_LANGUAGE_BLOCKS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_ALL_LANGUAGE_BLOCKS:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_ALL_LANGUAGE_BLOCKS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });

        case REQUEST_FETCH_LANGUAGE_BLOCKS_BY_QUERY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_QUERY:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_LANGUAGE_BLOCKS_BY_QUERY:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });

        case REQUEST_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });

        default:
            return state;
    }
}

export function languageTemplateTranslationsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function textBlockLanguagesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_TEXT_BLOCK_LANGUAGES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_TEXT_BLOCK_LANGUAGES:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_TEXT_BLOCK_LANGUAGES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function marketingDocumentsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_ALL_REGION_BLOCKS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_ALL_REGION_BLOCKS:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_ALL_REGION_BLOCKS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function documentRegionsByTemplateKeyReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
